import { render, staticRenderFns } from "./problemCalendar.vue?vue&type=template&id=8b20f376"
import script from "./problemCalendar.vue?vue&type=script&lang=js"
export * from "./problemCalendar.vue?vue&type=script&lang=js"
import style0 from "./problemCalendar.vue?vue&type=style&index=0&id=8b20f376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports